import React, { useState } from "react";
import { api, formatApiError } from "@/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Loader2, Save } from "lucide-react";
import { MetierPicker } from "@/components/metiers/MetierPicker";

/** Rattachement des métiers d'une entreprise (admin : principal + secondaires, sans restriction). */
export const EntrepriseMetiersDialog = ({ open, onOpenChange, entreprise, onSaved }) => {
  const [code, setCode] = useState(entreprise?.metier_code || null);
  const [secs, setSecs] = useState(entreprise?.metiers_secondaires || []);
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      await api.post(`/admin/entreprises/${entreprise.id}/metiers`, { metier_code: code, metiers_secondaires: secs });
      toast.success("Métiers enregistrés"); onSaved(); onOpenChange(false);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Enregistrement impossible"); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !busy && onOpenChange(o)}>
      <DialogContent className="max-w-3xl" data-testid="entreprise-metiers-dialog">
        <DialogHeader><DialogTitle className="font-display text-2xl font-black">Modules métier</DialogTitle><DialogDescription className="text-xs">Le métier principal pilote le secteur et les modules conditionnels (HACCP, rondes, réservations…). Les métiers secondaires ajoutent leurs modules.</DialogDescription></DialogHeader>
        <MetierPicker value={code} onChange={setCode} secondaires={secs} onSecondairesChange={setSecs} testid="ent-metier-picker" />
        <div className="flex justify-end gap-2"><Button variant="outline" onClick={() => onOpenChange(false)} disabled={busy} className="h-10" data-testid="ent-metiers-cancel">Annuler</Button><Button onClick={save} disabled={busy || !code} className="h-10 bg-[#0A0A0A] hover:bg-[#333] text-white font-bold" data-testid="ent-metiers-save">{busy ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <Save className="h-4 w-4 mr-2" />}Enregistrer</Button></div>
      </DialogContent>
    </Dialog>
  );
};
